/// <reference path="../../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import {SFC} from "react";

export const EmptyBotPage : SFC<React.Props<{}>> = ({}) => (
    <div className="bot-page pending">
    </div>
);





// WEBPACK FOOTER //
// ./Client/v4/Views/EmptyBotPage.tsx